/* eslint-disable @typescript-eslint/no-explicit-any */
import request from '@/utils/request'
import { download } from '@/utils/file'

//修改密码
export const updatePwd = (data: { oldPwd: string; smsCode?: string; password?: string }) => {
  return request.post('/user/updatePwd', data)
}

//重置密码
export const resetPwd = (data: { id: string }) => {
  return request.post('/user/resetPwd', data)
}

// 列表
export function list(data: any) {
  return request.post('/user/list', data)
}
// 列表
export function userList(data: any) {
  return request.post('/user/userList', data)
}

// 新增
export function add(data: any) {
  return request.post('/user/add', data)
}

// 编辑
export function update(data: any) {
  return request.post('/user/update', data)
}

// 禁用
export function disable(data: any) {
  return request.post('/user/ban', data)
}

// 导出
export function downloadFile(data: { nickName: string; roleId: string; firmId: string, fileName: string }) {
  return download('/user/export', data, data.fileName)
}

// 获取用户详情
export function getUserDataScope(data: any) {
  return request.post('user/getUserDataScope', data)
}

// 查看是否为原始密码
export function verifyPwd(data: any) {
  return request.get('/user/verifyPwd', data)
}


